module.exports = "/_next/static/images/ml-6a7164947b1ce10464077e281f59a3db.svg";